function Testimonials() {
  return (
<section className="testimonials" id="reviews">
          <h2>Happy Furry Parents 🐾</h2>

      <div className="testimonial-grid">

        <div className="testimonial-card">
          <p>
            "The velvet cat bed is unbelievably soft. My Persian cat refuses to sleep anywhere else now!"
          </p>
          <div className="stars">⭐⭐⭐⭐⭐</div>
          <span>- Ananya R., Delhi</span>
        </div>

        <div className="testimonial-card">
          <p>
            "Finally found a collar that looks premium and doesn’t irritate my kitten. Packaging was beautiful too!"
          </p>
          <div className="stars">⭐⭐⭐⭐⭐</div>
          <span>- Riya S., Mumbai</span>
        </div>

        <div className="testimonial-card">
          <p>
            "Fast Instagram response and smooth ordering process. Loved the personal touch in delivery."
          </p>
          <div className="stars">⭐⭐⭐⭐⭐</div>
          <span>- Karan M., Bangalore</span>
        </div>

      </div>
    </section>
  );
}

export default Testimonials;